import { Mail } from 'lucide-react'
import type { NotificationEmail } from '../types'

interface NotificationEmailsListProps {
  emails: NotificationEmail[]
  isLoading: boolean
}

export function NotificationEmailsList({ emails, isLoading }: NotificationEmailsListProps) {
  if (isLoading) {
    return (
      <div className="space-y-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="animate-pulse h-12 bg-gray-100 rounded-lg" />
        ))}
      </div>
    )
  }

  if (emails.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No hay emails de notificacion configurados
      </div>
    )
  }

  return (
    <div className="space-y-2">
      {emails.map((entry, index) => (
        <div
          key={entry.key}
          className="flex items-center gap-3 p-3 border border-gray-200 rounded-lg"
        >
          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-50 flex items-center justify-center">
            <Mail size={16} className="text-primary-600" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">
              {entry.email}
            </p>
          </div>
          <span className="text-xs text-gray-400">
            #{index + 1}
          </span>
        </div>
      ))}
    </div>
  )
}
